module.exports = __webpack_public_path__ + "img/UnityFrameworkPresentation.510f6feb.png";